const FREE_PLAN_SKU = 'free_plan_1';
const PREMIUM_FREE_TRIAL_SKU = 'cr-anime-membership-freetrial-1';
const PREMIUM_PLUS_FREE_TRIAL_SKU =
  'cr-combo-anime-drama-manga-membership-freetrial-1';
const FAN_PACK_FREE_TRIAL_SKU = 'cr-fan-membership-freetrial-1';
const FAN_PACK_FREE_TRIAL_SKU_12 = 'cr-fan-membership-freetrial-12';
const SUPER_FAN_PACK_FREE_TRIAL_SKU = 'cr-superfan-membership-freetrial-1';

const PREMIUM_PLAN_1_MONTH_SKU = 'cr-anime-membership-1-0901';
const PREMIUM_PLAN_3_MONTHS_SKU = 'cr-anime-membership-3-0901';
const PREMIUM_PLAN_12_MONTHS_SKU = 'cr-anime-membership-12-0901';
const FAN_PACK_PLAN_1_MONTH_SKU = 'cr-fan-membership-recur-1-1802';
const FAN_PACK_PLAN_12_MONTH_SKU = 'cr-fan-membership-recur-12-2005';
const SUPER_FAN_PACK_PLAN_SKU = 'cr-superfan-membership-recur-1-1802';

// ETP SKU constants needed for checkout_v2
const PREMIUM_1_MONTH_SKU = 'cr_premium.1_month';
const PREMIUM_3_MONTHS_SKU = 'cr_premium.3_month';
const PREMIUM_12_MONTHS_SKU = 'cr_premium.1_year';
const FAN_PACK_1_MONTH_SKU = 'cr_fan_pack.1_month';
const FAN_PACK_12_MONTH_SKU = 'cr_fan_pack.1_year';
const SUPER_FAN_PACK_1_MONTH_SKU = 'cr_super_fan_pack.1_month';

const CTP_SKU_BY_LEGACY_SKU = {
  [PREMIUM_FREE_TRIAL_SKU]: PREMIUM_1_MONTH_SKU,
  [PREMIUM_PLUS_FREE_TRIAL_SKU]: SUPER_FAN_PACK_1_MONTH_SKU,
  [FAN_PACK_FREE_TRIAL_SKU]: FAN_PACK_1_MONTH_SKU,
  [FAN_PACK_FREE_TRIAL_SKU_12]: FAN_PACK_12_MONTH_SKU,
  [SUPER_FAN_PACK_FREE_TRIAL_SKU]: SUPER_FAN_PACK_1_MONTH_SKU,
  [PREMIUM_PLAN_1_MONTH_SKU]: PREMIUM_1_MONTH_SKU,
  [PREMIUM_PLAN_3_MONTHS_SKU]: PREMIUM_3_MONTHS_SKU,
  [PREMIUM_PLAN_12_MONTHS_SKU]: PREMIUM_12_MONTHS_SKU,
  [FAN_PACK_PLAN_1_MONTH_SKU]: FAN_PACK_1_MONTH_SKU,
  [FAN_PACK_PLAN_12_MONTH_SKU]: FAN_PACK_12_MONTH_SKU,
  [SUPER_FAN_PACK_PLAN_SKU]: SUPER_FAN_PACK_1_MONTH_SKU,
};

const PLAN_TITLES_BY_SKU = {
  [PREMIUM_PLAN_1_MONTH_SKU]: 'Fan 1 month',
  [PREMIUM_PLAN_3_MONTHS_SKU]: 'Fan 3 months',
  [PREMIUM_PLAN_12_MONTHS_SKU]: 'Fan 12 months',
  [FAN_PACK_PLAN_1_MONTH_SKU]: 'Mega Fan 1 month',
  [FAN_PACK_PLAN_12_MONTH_SKU]: 'Mega Fan 12 months',
  [SUPER_FAN_PACK_PLAN_SKU]: 'Ultimate Fan 1 month',
  [PREMIUM_1_MONTH_SKU]: 'Fan 1 month',
  [PREMIUM_3_MONTHS_SKU]: 'Fan 3 month',
  [PREMIUM_12_MONTHS_SKU]: 'Fan 12 months',
  [FAN_PACK_1_MONTH_SKU]: 'Mega Fan 1 month',
  [FAN_PACK_12_MONTH_SKU]: 'Mega Fan 12 months',
  [SUPER_FAN_PACK_1_MONTH_SKU]: 'Ultimate Fan 1 month',
};

const ACCESS_TYPE_BY_SKU = {
  [PREMIUM_FREE_TRIAL_SKU]: 'Fan',
  [PREMIUM_PLUS_FREE_TRIAL_SKU]: 'Fan',
  [FAN_PACK_FREE_TRIAL_SKU]: 'Mega Fan',
  [FAN_PACK_FREE_TRIAL_SKU_12]: 'Mega Fan',
  [SUPER_FAN_PACK_FREE_TRIAL_SKU]: 'Ultimate Fan',
  [PREMIUM_1_MONTH_SKU]: 'Fan',
  [PREMIUM_3_MONTHS_SKU]: 'Fan',
  [PREMIUM_12_MONTHS_SKU]: 'Fan',
  [FAN_PACK_1_MONTH_SKU]: 'Mega Fan',
  [FAN_PACK_12_MONTH_SKU]: 'Mega Fan',
  [SUPER_FAN_PACK_1_MONTH_SKU]: 'Ultimate Fan',
};

const SKU_BY_BENEFIT_SKU = {
  'cr_premium_plus.1_month': PREMIUM_PLUS_FREE_TRIAL_SKU,
  'cr_premium.1_month': PREMIUM_FREE_TRIAL_SKU,
  'cr_fan_pack.1_month': FAN_PACK_FREE_TRIAL_SKU,
  'cr_super_fan_pack.1_month': SUPER_FAN_PACK_FREE_TRIAL_SKU,
  'cr_fan_pack.1_year': FAN_PACK_FREE_TRIAL_SKU_12,
};

const skuTitleBy = (sku, weeks) =>
  `${ACCESS_TYPE_BY_SKU[sku]} Membership - ${weeks} Week Free Trial`;

const FREE_TRIAL_SKUS_ARRAY = [
  PREMIUM_FREE_TRIAL_SKU,
  PREMIUM_PLUS_FREE_TRIAL_SKU,
  FAN_PACK_FREE_TRIAL_SKU,
  FAN_PACK_FREE_TRIAL_SKU_12,
  SUPER_FAN_PACK_FREE_TRIAL_SKU,
  // CTP SKUs
  PREMIUM_1_MONTH_SKU,
  PREMIUM_3_MONTHS_SKU,
  PREMIUM_12_MONTHS_SKU,
  FAN_PACK_1_MONTH_SKU,
  FAN_PACK_12_MONTH_SKU,
  SUPER_FAN_PACK_1_MONTH_SKU,
];

const SUBSCRIPTION_SKUS_ARRAY = [
  PREMIUM_PLAN_1_MONTH_SKU,
  PREMIUM_PLAN_3_MONTHS_SKU,
  PREMIUM_PLAN_12_MONTHS_SKU,
  FAN_PACK_PLAN_1_MONTH_SKU,
  FAN_PACK_PLAN_12_MONTH_SKU,
  SUPER_FAN_PACK_PLAN_SKU,
  // CTP SKUs
  PREMIUM_1_MONTH_SKU,
  PREMIUM_3_MONTHS_SKU,
  PREMIUM_12_MONTHS_SKU,
  FAN_PACK_1_MONTH_SKU,
  FAN_PACK_12_MONTH_SKU,
  SUPER_FAN_PACK_1_MONTH_SKU,
];

const LENGTH_OF_MIGRATION_FREE_TRIAL = '60 days';
const LENGTH_OF_COUPON_FREE_TRIAL = 'Extended free trial';

export {
  FREE_PLAN_SKU,
  PREMIUM_FREE_TRIAL_SKU,
  PREMIUM_PLUS_FREE_TRIAL_SKU,
  FAN_PACK_FREE_TRIAL_SKU,
  FAN_PACK_FREE_TRIAL_SKU_12,
  SUPER_FAN_PACK_FREE_TRIAL_SKU,
  PLAN_TITLES_BY_SKU,
  FREE_TRIAL_SKUS_ARRAY,
  skuTitleBy,
  SUBSCRIPTION_SKUS_ARRAY,
  LENGTH_OF_COUPON_FREE_TRIAL,
  PREMIUM_PLAN_1_MONTH_SKU,
  PREMIUM_PLAN_3_MONTHS_SKU,
  PREMIUM_PLAN_12_MONTHS_SKU,
  FAN_PACK_PLAN_1_MONTH_SKU,
  FAN_PACK_PLAN_12_MONTH_SKU,
  SUPER_FAN_PACK_PLAN_SKU,
  LENGTH_OF_MIGRATION_FREE_TRIAL,
  SKU_BY_BENEFIT_SKU,
  CTP_SKU_BY_LEGACY_SKU,
};
